import { Undo } from '@mui/icons-material';
import { FC } from 'react';
import { Link } from 'react-router';
import { RoutePath } from '../../utils/Routes';
import { Button } from '@mui/material';

interface IAmendButtonLink {
	text?: string;
	to: RoutePath;
}

const AmendButtonLink: FC<IAmendButtonLink> = ({ to, text }) => {
	return (
		<Button
			component={Link}
			to={to}
			data-testid={'amend-button'}
			style={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				textDecoration: 'none',
				border: '1px solid',
				borderColor: 'secondary.main',
				padding: '6px 16px',
				borderRadius: '4px',
				maxWidth: '500px',
				margin: '0 auto',
				whiteSpace: 'nowrap',
				color: 'secondary.main',
				transition: 'background-color 0.3s',
			}}
		>
			<Undo style={{ marginRight: '8px' }} />
			{text ?? 'Amend'}
		</Button>
	);
};

export default AmendButtonLink;
